<!-- @format -->

<template>
	<div class="name-chip">
		<span class="name-chip__label">{{ token }}</span>
		<span
			class="name-chip__handle"
			aria-hidden="true"
		>
			<span class="pi pi-ellipsis-v name-chip__handle-dots"></span>
			<span class="pi pi-ellipsis-v name-chip__handle-dots"></span>
		</span>
	</div>
</template>

<script>
export default {
	name: 'NameChip',

	props: {
		token: {
			type: String,
			required: true,
		},
	},
}
</script>

<style scoped>
.name-chip {
	display: inline-flex;
	align-items: center;
	gap: 0.9rem;
	padding: 1rem 1.4rem;
	background: var(--color-primary-300);
	border: 1.5px solid var(--color-primary-600);
	border-radius: 999px;
	font-size: 1.6rem;
	font-weight: 500;
	user-select: none;
	cursor: grab;
	min-width: 6rem;
	justify-content: space-between;
}

.name-chip:active {
	cursor: grabbing;
}

.name-chip__label {
	line-height: 1;
}

.name-chip__handle {
	display: inline-flex;
	gap: 0.05rem;
	color: var(--color-neutral-900);
	flex-shrink: 0;
}

.name-chip__handle-dots {
	font-size: 1.4rem;
}
</style>
